import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    privacy: false,
    loggedIn: false,
    authInfo: {
      id: null,
      email: null,
      preName: null,
      lastName: null,
      permissions: null,
    },
    results: [],
    matching_results: 0,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
